import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import ReportsHome from './ReportsHome';
import ProductInventoryDashboard from './ProductInventoryDashboard';
import TotalSalesDashboard from './TotalSalesDashboard';
import SalesByProductDashboard from './SalesByProductDashboard';
import EarningsByBatchDashboard from './EarningsByBatchDashboard';
import PaymentsActiveMembershipsByMonthReport from './payments/PaymentsActiveMembershipsByMonthReport';
import PaymentsActiveClientsCountsReport from './payments/PaymentsActiveClientsCountsReport';
import PaymentsIncomeByDateRangeReport from './payments/PaymentsIncomeByDateRangeReport';
import CleaningHoursWagesByCleanerReport from './cleaning/CleaningHoursWagesByCleanerReport';
import CleaningHoursByClientReport from './cleaning/CleaningHoursByClientReport';
import ClinicAppointmentBookingsReport from './clinic/ClinicAppointmentBookingsReport';
import AttendanceStudentSummaryReport from './attendance/AttendanceStudentSummaryReport';

const Reports = () => {
  return (
    <Routes>
      <Route path="/" element={<ReportsHome />} />

      {/* Existing reports */}
      <Route
        path="/product-inventory"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <ProductInventoryDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/total-sales"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <TotalSalesDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sales-by-product"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <SalesByProductDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/earnings-by-batch"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <EarningsByBatchDashboard />
          </ProtectedRoute>
        }
      />

      {/* Payments reports */}
      <Route
        path="/payments/active-memberships-by-month"
        element={
          <ProtectedRoute requiredPermission="reports.payments.active_memberships_by_month">
            <PaymentsActiveMembershipsByMonthReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payments/active-clients-counts"
        element={
          <ProtectedRoute requiredPermission="reports.payments.active_clients_counts">
            <PaymentsActiveClientsCountsReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payments/income-by-date-range"
        element={
          <ProtectedRoute requiredPermission="reports.payments.income_by_date_range">
            <PaymentsIncomeByDateRangeReport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/cleaning/hours-wages-by-cleaner"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <CleaningHoursWagesByCleanerReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cleaning/hours-by-client"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <CleaningHoursByClientReport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/clinic/appointment-bookings"
        element={
          <ProtectedRoute requiredPermission="reports.view">
            <ClinicAppointmentBookingsReport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance/student-summary"
        element={
          <ProtectedRoute requiredPermission="attendances.view">
            <AttendanceStudentSummaryReport />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/reports" replace />} />
    </Routes>
  );
};

export default Reports;

